import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalDataService } from '../../../services/global-data.service';


@Injectable()
export class OperationTypeService {

  constructor(
  			  private http: HttpClient,
  			  private global: GlobalDataService
  			 ) {}

    getContractorTypeList() {
        return this.http.get(this.global.httpUrl+"operation-types");
    }


}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/operation_types/operation-type.service.ts